import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components';

import hospitalLogo from '../../images/consultations/new-flow/hospital-building.png';
import doctorPlaceHolder from '../../images/consultations/doctor-placeholder.svg';
import arrowForward from '../../images/arrow_forward.svg';
import medal from '../../images/medal.svg';
import megaPhone from '../../images/megaphone.svg';
import clock from '../../images/lab-test/clock.svg';

const OuterContainer = styled.button`
  width: 100%;
  margin-bottom: 20px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  width: 100%;
  justify-content: space-between;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-left: 12px;
`;

const Profession = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #585969;
`;

const DoctorName = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const ArrowForward = styled.img.attrs({
  src: arrowForward,
})`
  height: 30px;
  width: 30px;
  top: 12px;
  position: absolute;
  right: 10px;
  top: 10px;
`;

const DoctorImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  src: url(${(props) => props.src});
  border: 1.5px solid
    ${(props) => (props.isActive === true ? '#1eb865' : '#F0F3F6')};
`;

const SponsorLogo = styled.img`
  height: 20px;
  max-width: 60px;
  width: auto;
  object-fit: contain;
`;

const OnlineActive = styled.div`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  border: 1.5px solid #fff;
  background: #1eb865;
  box-shadow: 0px 0px 4px 0px #00000040;
  position: absolute;
  bottom: 3px;
  right: 3px;
`;

const Experience = styled.div`
  background: rgba(255, 134, 92, 0.06);
  border-radius: 40px;
  margin-top: 12px;
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 8px 13px;
`;

const Languages = styled.div`
  background: rgba(63, 140, 255, 0.05);
  border-radius: 40px;
  margin-top: 12px;
  display: flex;
  width: fit-content;
  align-items: center;
  margin-right: 20px;
  text-wrap: break;
  flex-direction: row;
  padding: 8px 13px;
`;

const OrgName = styled.div`
  background: rgba(30, 184, 101, 0.06);
  border-radius: 40px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  flex-direction: row;
  padding: 8px 13px;
  gap: 4px;
`;

const LanguageText = styled.div`
  font-weight: 500;
  font-size: 12px;
  word-break: break-word;
  line-height: 150%;
  color: #585969;
  text-align: start;
`;

const Education = styled.div`
  background: rgba(255, 241, 253, 0.7);
  border-radius: 40px;
  margin-top: 12px;
  display: flex;
  gap: 6px;
  align-items: center;
  flex-direction: row;
  padding: 8px 13px;
  width: fit-content;
  max-width: 300px;
`;

const RowTopBottomBorder = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid #f4f6f9;
  border-bottom: 1px solid #f4f6f9;
  width: 100%;
  margin-top: 12px;
  justify-content: space-between;
  padding: 11px 20px 11px 22px;
`;

const PaidByText = styled.div`
  font-weight: 500;
  font-size: 12px;
  margin-right: 8px;
  line-height: 150%;
  color: #585969;
`;

const YouPayText = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;
const MaxPriceText = styled.div`
  margin-left: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.25px;
  text-decoration-line: line-through;
  color: #767787;
`;
const ActualPriceText = styled.div`
  font-weight: 600;
  font-size: 12px;
  margin-left: 8px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const BookAppointmentButton = styled.button`
  background: var(--primary-button);
  border-radius: 12px;
  margin: 16px 20px 16px 20px;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  width: calc(100% - 40px);
  padding: 12px;
  letter-spacing: 0.25px;
  color: #ffffff;
  &:active {
    opacity: 0.2;
  }
`;
const DoctorSelectCardNew = ({
  className,
  onTap,
  doctorPicture,
  doctorName,
  doctorQualifications,
  doctorExperience,
  orgName,
  responseTimeText,
  basePrice,
  doctorPrice,
  feesLabel,
  opdLabel,
  degree,
  bookingLabel,
  onBook,
  onOpd,
  sponsor,
  sponsorLogo,
  orgImg,
  discountLabel,
  knownLanguages,
  isActive,
}) => {
  const experienceRef = createRef(null);
  const languageRef = createRef(null);
  const degreeRef = createRef(null);
  const experienceRowRef = createRef(null);
  const [isLanguageInSameRow, setIsLanguageInSameRow] = useState(false);
  useEffect(() => {
    if (
      experienceRef.current &&
      languageRef.current &&
      experienceRowRef.current.clientWidth >
        experienceRef.current.clientWidth + languageRef.current.clientWidth + 52
    ) {
      setIsLanguageInSameRow(
        experienceRowRef.current.clientWidth >
          experienceRef.current.clientWidth +
            languageRef.current.clientWidth +
            52
      );
    }
  }, []);

  return (
    <OuterContainer onClick={onTap}>
      {responseTimeText.length > 0 && (
        <div className="flex flex-row items-center p-12px pb-20px rounded-t-12 text-body-s font-semibold text-txtsecondary-greyShade bg-txtsecondary-shades4 gap-12px h-80px">
          <img
            src={clock}
            alt="clock"
            style={{ height: '16px', width: '16px' }}
          />
          {responseTimeText}
        </div>
      )}
      <div className="flex flex-col relative rounded-12 border border-txtsecondary-shades7 items-start bg-textbox -mt-1">
        <div className="px-5 w-full">
          <Row>
            <div className="flex flex-row items-center">
              <div className="relative">
                <DoctorImage
                  src={doctorPicture ?? doctorPlaceHolder}
                  isActive={isActive}
                />
                {isActive && <OnlineActive />}
              </div>
              <Column>
                <DoctorName>{doctorName}</DoctorName>
                <Profession>{doctorQualifications}</Profession>
              </Column>
            </div>
            <ArrowForward />
          </Row>
          <div ref={experienceRowRef} className="flex flex-row w-full ">
            {doctorExperience && (
              <Experience ref={experienceRef}>
                <img
                  src={medal}
                  style={{ height: '20px', width: '20px' }}
                  alt="medal"
                />
                <LanguageText>{doctorExperience}</LanguageText>
              </Experience>
            )}

            {isLanguageInSameRow && knownLanguages && (
              <Languages
                isLanguageRefInSameRow={isLanguageInSameRow}
                ref={languageRef}
                style={{ marginLeft: '12px' }}
              >
                <img
                  src={megaPhone}
                  style={{ height: '20px', width: '20px' }}
                  alt="phone"
                />
                <LanguageText>{knownLanguages}</LanguageText>
              </Languages>
            )}
          </div>
          {!isLanguageInSameRow && knownLanguages && (
            <Languages
              isLanguageRefInSameRow={isLanguageInSameRow}
              ref={languageRef}
            >
              <img
                src={megaPhone}
                style={{ height: '20px', width: '20px' }}
                alt="phone"
              />
              <LanguageText>{knownLanguages}</LanguageText>
            </Languages>
          )}

          {degree && (
            <Education ref={degreeRef}>
              <div>
                <svg
                  width="15"
                  height="13"
                  viewBox="0 0 15 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.9443 8.66618V5.99951H14.1666V8.66618H13.9443Z"
                    fill="white"
                    stroke="#F598B6"
                  />
                  <path
                    d="M7.33323 9.05503C7.66716 9.05503 7.99267 8.98483 8.29877 8.8451C8.29897 8.845 8.29918 8.84491 8.29939 8.84482L11.7221 7.28968V9.77725C11.7221 10.2789 11.3421 10.7616 10.4848 11.1448C9.64825 11.5187 8.50025 11.7217 7.33323 11.7217C6.1662 11.7217 5.0182 11.5187 4.18163 11.1448C3.32434 10.7616 2.94434 10.2789 2.94434 9.77725V7.28923L6.3682 8.84566C6.36825 8.84569 6.36831 8.84571 6.36836 8.84574C6.36842 8.84576 6.36847 8.84579 6.36853 8.84582C6.67388 8.98484 6.9993 9.05503 7.33323 9.05503Z"
                    stroke="#F598B6"
                  />
                  <path
                    d="M14.1017 3.56528L14.1019 3.56541C14.1414 3.58332 14.1667 3.62218 14.1667 3.66621C14.1667 3.71024 14.1414 3.7491 14.1019 3.767L14.1017 3.76714L7.37943 6.82269L7.58633 7.27787L7.37943 6.82269C7.36397 6.82972 7.34838 6.83288 7.33333 6.83288C7.31829 6.83288 7.30269 6.82972 7.28724 6.82269L7.08033 7.27787L7.28724 6.82269L0.565013 3.76714L0.564724 3.767C0.525258 3.7491 0.5 3.71024 0.5 3.66621C0.5 3.62239 0.525014 3.58366 0.564857 3.56563L0.565624 3.56528L7.28706 0.51008C7.28715 0.510042 7.28723 0.510004 7.28731 0.509966C7.31687 0.496677 7.35041 0.496678 7.37997 0.509968C7.38005 0.510006 7.38013 0.510043 7.38021 0.51008L14.1017 3.56528Z"
                    stroke="#F598B6"
                  />
                </svg>
              </div>

              <LanguageText className="truncate">{degree}</LanguageText>
            </Education>
          )}

          {orgName && (
            <OrgName>
              <img
                src={hospitalLogo}
                style={{ height: '20px', width: '20px' }}
                alt="hospital-logo"
              />
              <LanguageText>{orgName}</LanguageText>
            </OrgName>
          )}
        </div>
        <RowTopBottomBorder>
          <div className="flex flex-row items-center">
            {discountLabel ? (
              <>
                {<PaidByText>{discountLabel}</PaidByText>}
                {sponsorLogo ? (
                  <SponsorLogo src={sponsorLogo} alt="logo" className="pl-4px" />
                ) : (
                  ''
                )}
              </>
            ) : (
              <PaidByText>{feesLabel}</PaidByText>
            )}
          </div>
          <div className="flex flex-row">
            <YouPayText>You Pay</YouPayText>
            {
              basePrice !== doctorPrice && (
                <MaxPriceText>{`₹${basePrice}`}</MaxPriceText>
              )
            }
            <ActualPriceText>{`₹${doctorPrice}`} </ActualPriceText>
          </div>
        </RowTopBottomBorder>
        <BookAppointmentButton
          onClick={(e) => {
            onBook(bookingLabel ? 'bn' : 'bfl');
            //bn=book now   bfl=book for later
            e.stopPropagation();
          }}
        >
          {bookingLabel ? bookingLabel : 'Book for later'}
        </BookAppointmentButton>
      </div>
    </OuterContainer>
  );
};

export default DoctorSelectCardNew;
